export const FormDependencyTypes = {
  FormValidationService: Symbol.for('FormValidationService'),
  FreeTextLocaleSynchronizationService: Symbol.for('FreeTextLocaleSynchronizationService'),
  FormFieldViewRegistryService: Symbol.for('FormFieldViewRegistryService'),
  ToFormDataApiDataTransformer: Symbol.for('ToFormDataApiDataTransformer'),
  FormFieldViewKeyComponents: Symbol.for('FormFieldViewKeyComponents'),
  FormFieldBooleanComponent: Symbol.for('FormFieldBooleanComponent'),
  FormFieldTextComponent: Symbol.for('FormFieldTextComponent'),
  FormFieldNumberComponent: Symbol.for('FormFieldNumberComponent'),
  FormFieldMoneyComponent: Symbol.for('FormFieldMoneyComponent'),
  FormFieldSelectComponent: Symbol.for('FormFieldSelectComponent'),
  FormFieldFileComponent: Symbol.for('FormFieldFileComponent'),
  FormFieldDateComponent: Symbol.for('FormFieldDateComponent'),
  FormFieldTranslatedPropertyComponent: Symbol.for('FormFieldTranslatedPropertyComponent'),
};
